import React from "react";
import { Box, Container, Paper, Typography, Divider } from "@mui/material";

const RefundReturn = () => {
    return (
        <Box sx={{ py: 5, background: "#fafafa" }}>
            <Container maxWidth="md">

                <Typography
                    variant="h3"
                    align="center"
                    color="#f5b600"
                    fontWeight="bold"
                    gutterBottom
                >
                    Refund & Return Policy
                </Typography>

                <Paper sx={{ p: 4, borderRadius: 3 }}>

                    <Typography variant="h5">
                        Refund Policy
                    </Typography>

                    <Typography paragraph>
                        Refunds are available only for:
                    </Typography>

                    <Typography paragraph>
                        • Damaged products
                        <br />
                        • Incorrect products
                        <br />
                        • Manufacturing defects
                    </Typography>

                    <Typography paragraph>
                        Refund requests must include clear photos or videos for
                        verification.
                    </Typography>

                    <Typography paragraph>
                        Approved refunds will be processed within
                        <strong> 4–5 working days </strong>
                        to the original payment method.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h5">
                        Return Policy
                    </Typography>

                    <Typography paragraph>
                        Returns are accepted within
                        <strong> 7 working days </strong>
                        from delivery only if:
                    </Typography>

                    <Typography paragraph>
                        • Product is damaged
                        <br />
                        • Wrong product delivered
                        <br />
                        • Verified manufacturing defect
                    </Typography>

                    <Typography paragraph>
                        Products must be unused and returned in their original
                        packaging with invoice and accessories.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h5">
                        Replacement Policy
                    </Typography>

                    <Typography paragraph>
                        Replacement requests should be raised within
                        <strong> 3–4 working days </strong>
                        after delivery.
                    </Typography>

                    <Typography paragraph>
                        Customized furniture is not eligible for replacement unless
                        there is a verified manufacturing defect.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h5">
                        Cancellation Policy
                    </Typography>

                    <Typography paragraph>
                        Orders can be cancelled before dispatch. Once shipped,
                        cancellation requests cannot be accepted.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h5" sx={{ mt: 4 }}>
                        Shipping Policy
                    </Typography>

                    <Typography paragraph>
                        We deliver our products across India through trusted logistics and courier
                        partners. Every order is carefully packed to ensure it reaches you in good
                        condition.
                    </Typography>

                    <Typography paragraph>
                        <strong>Order Processing:</strong> Orders are generally processed and
                        dispatched within <strong>1–3 business days</strong> after successful payment
                        confirmation. Customized or made-to-order products may require additional
                        processing time.
                    </Typography>

                    <Typography paragraph>
                        <strong>Delivery Time:</strong> Delivery timelines vary depending on your
                        location, product availability, and courier services. Most orders are
                        delivered within <strong>5–10 business days</strong> after dispatch, although
                        remote locations may require additional time.
                    </Typography>

                    <Typography paragraph>
                        <strong>Order Tracking:</strong> Once your order has been shipped, tracking
                        details will be shared via email or phone, allowing you to monitor your
                        shipment.
                    </Typography>

                    <Typography paragraph>
                        <strong>Delivery Delays:</strong> While we strive to deliver orders on time,
                        delays caused by courier services, weather conditions, natural disasters, or
                        other unforeseen circumstances are beyond our control.
                    </Typography>

                    <Typography paragraph>
                        <strong>Delivery Inspection:</strong> Customers are requested to inspect the
                        package at the time of delivery. If the package appears damaged or tampered
                        with, please notify the delivery personnel and contact our support team
                        immediately.
                    </Typography>

                </Paper>

            </Container>
        </Box>
    );
};

export default RefundReturn;